<!--
 * @Date: 2021-03-10 13:56:18
 * @Description: b-icon
-->
<template>
    <svg
        class="b-icon"
        aria-hidden="true"
        :style="{ color, ...$attrs.style }"
        :width="size"
        :height="size"
    >
        <use :xlink:href="icon"></use>
    </svg>
</template>

<script>
export default {
    name: 'b-icon',
    props: {
        name: {
            type: String,
            required: true
        },
        color: {
            type: String
        },
        size: {
            type: [String, Number],
            default: '24px'
        }
    },
    computed: {
        icon() {
            return `#icon-${this.name}`;
        }
    }
};
</script>

<style>
.b-icon {
    overflow: hidden;
    font-size: inherit;
    vertical-align: -0.15em;
    fill: currentColor;
}
</style>
